<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import Cookies from 'js-cookie'
export default {
  name: 'App',
  data() {
    return {
      faviconOption: [
        // { hostname: 'smartparking.sensetime.com', favicon: '/favicon-sst.ico' },
        // { hostname: 'intelligentparking.sensetime.com', favicon: '/favicon-sst.ico' },
        { hostname: 'dsrepark.com', favicon: '/favicon.ico' },
        { hostname: 'parking.swzhtc.com', favicon: '/favicon-sw.ico' },
        { hostname: '125.94.68.38', favicon: '/favicon-mh.ico' },
        // { hostname: 'parking.renrenting.vip', favicon: '/favicon-rr.ico' },
        { hostname: 'parking.szrepark.com', favicon: '/favicon-rh.ico' },
        // { hostname: '120.25.167.21', favicon: '/favicon-yd.ico' },
        // { hostname: 'parking.jiuzhouzulin.com', favicon: '/favicon-jz.ico' },
        { hostname: 'parking.zyszhcs.cn', favicon: '/favicon-zy.ico' },
        { hostname: 'www.ltparking.cn', favicon: '/favicon.ico' }
      ]
    }
  },
  created() {
    const account = Cookies.get('account')
    this.changeFavicon(account)
  },
  mounted() {
    this.loadMapInit()
  },
  methods: {
    loadMapInit() {
      window._AMapSecurityConfig = {
        serviceHost: `${window.BaseUrl.VUE_APP_DOWNLOAD}/_AMapService`
      }
      AMapLoader.load({
        key: window.BaseUrl.VUE_APP_MAP_API, // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Geocoder'] // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
    },
    changeFavicon(account) {
      let favicon = document.querySelector('link[rel="icon"]')
      favicon = document.createElement('link')
      favicon.rel = 'icon'
      if (account == null || account === '') {
        favicon.href = '/favicon.ico'
      } else {
        favicon.href = `/favicon-${account}.ico`
      }
      document.head.appendChild(favicon)
    }
  }
}
</script>

<style>
@font-face {
  font-family: 'Time';
  src: url('./assets/font/SanJiXiXiangJianTi-2.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
</style>
